import React, { useState } from 'react';
import { Box, Card, CardHeader, CardBody, Heading, Text, Button, Flex, Icon, Badge, useToast, Divider, Textarea } from '@chakra-ui/react';
import { FiAlertCircle, FiSend, FiX, FiEdit2 } from 'react-icons/fi';
import FqClaimDetailShell from './FqClaimDetailShell';

const mockData = {
  type: '835 Denial',
  patient: { first_name: 'Linda', last_name: 'Martinez', member_id: 'MC998877665' },
  provider: { name: 'Dr. Alan Turing', npi: '4321098765' },
  claim: {
    diagnoses: ['Z01.00'], // Encounter for examination of eyes and vision without abnormal findings
    procedures: [
      { cpt: '92004', modifiers: [], charge: 180.00 }, // Eye exam, new patient
      { cpt: '0521', modifiers: [], charge: 0.00 } // Clinic visit
    ],
    clinical_note: "Patient presents for comprehensive eye examination. Complains of blurry vision when reading. Refraction performed. Prescription updated. No signs of glaucoma or macular degeneration."
  }
};

const FqDemoAppealDraft = () => {
  const [isApproved, setIsApproved] = useState(false);
  const [appealText, setAppealText] = useState(`To Whom It May Concern,

We are appealing the denial of claim for patient Linda Martinez (ID: MC998877665) for date of service. The claim was denied with CARC 16 (Claim/service lacks information or has billing error(s)).

This claim was billed with revenue code 0521 and CPT 92004 for a comprehensive optometry visit. Per the DHCS FQHC/RHC Provider Manual, optometry services are billable as a PPS encounter using the 0521 revenue code and the appropriate CPT code (92004 or 92014). The T1015 code is not required for optometry encounters.

Please review the attached clinical documentation which supports the services rendered, and reprocess this claim for payment at our PPS rate.

Sincerely,
Billing Department`);
  const toast = useToast();

  const handleApprove = () => {
    setIsApproved(true);
    toast({
      title: "Appeal Sent",
      description: "Appeal letter and supporting documentation have been queued for submission.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  const rightPanel = (
    <Card borderColor="purple.200" borderWidth="2px" shadow="md">
      <CardHeader bg="purple.50" pb={4}>
        <Flex justify="space-between" align="center">
          <Heading size="md" display="flex" alignItems="center" color="purple.800">
            <Icon as={FiAlertCircle} mr={2} />
            Revedy Action Required
          </Heading>
          <Badge colorScheme="purple" variant="solid">Tier B</Badge>
        </Flex>
      </CardHeader>
      <CardBody>
        <Box mb={4}>
          <Text fontWeight="bold" color="red.600" mb={1}>Denial Reason (CARC 16):</Text>
          <Text fontSize="sm">Claim/service lacks information or has billing error(s) which is needed for adjudication. (Missing T1015)</Text>
        </Box>
        
        <Divider my={4} />

        <Box mb={4}>
          <Text fontWeight="bold" color="purple.700" mb={1}>Revedy Analysis:</Text>
          <Text fontSize="sm" mb={2}>
            The payer incorrectly denied this optometry claim for missing the T1015 code. Optometry is a valid PPS encounter but uses a different code set than standard medical visits.
          </Text>
        </Box>

        <Box mb={4} p={3} bg="gray.50" borderRadius="md" borderLeft="4px solid" borderLeftColor="purple.400">
          <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" mb={1}>Rule Citation:</Text>
          <Text fontSize="sm" fontStyle="italic">"Optometry services are billed with revenue code 0521 and CPT codes 92004 or 92014. The T1015 code is not used for optometry encounters." (DHCS FQHC/RHC Manual)</Text>
        </Box>

        <Box mb={6}>
          <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" mb={1}>Drafted Appeal Letter:</Text>
          <Textarea 
            value={appealText}
            onChange={(e) => setAppealText(e.target.value)}
            size="sm"
            rows={10}
            isDisabled={isApproved}
          />
        </Box>

        <Flex gap={3}>
          <Button 
            flex="1" 
            colorScheme="purple" 
            leftIcon={<FiSend />} 
            onClick={handleApprove}
            isDisabled={isApproved}
          >
            {isApproved ? 'Sent' : 'Approve & Send'}
          </Button>
          <Button variant="ghost" colorScheme="red" isDisabled={isApproved}>
            <Icon as={FiX} />
          </Button>
        </Flex>
      </CardBody>
    </Card>
  );

  return <FqClaimDetailShell claimData={mockData} rightPanel={rightPanel} backTo="/fq/835-review" />;
};

export default FqDemoAppealDraft;